import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter, routerShape } from 'react-router';
import { bindActionCreators } from 'redux';
import BCReactComponent from '@bibliocommons/base-bc-react-component';
import { SavedSearchForm } from '@bibliocommons/saved-search';
import SavedSearchActions from '../actions/SavedSearchActions';

export class SaveSearchContainer extends BCReactComponent {
  render() {
    const { router, ...props } = this.props;
    return (
      <SavedSearchForm
        {...props}
        searchQuery={router.location.query.query} />
    );
  }
}

SaveSearchContainer.propTypes = {
  isSaving: PropTypes.bool,
  isDuplicate: PropTypes.bool,
  lastNameAttempt: PropTypes.string,
  saveSearch: PropTypes.func.isRequired,
  replaceSearch: PropTypes.func.isRequired,
  chooseNewName: PropTypes.func.isRequired,
  closeWorkflow: PropTypes.func.isRequired,
  router: routerShape
};

const mapStateToProps = (state) => ({
  isSaving: state.getIn(['ui', 'savedSearch', 'isSaving']),
  isDuplicate: state.getIn(['ui', 'savedSearch', 'isDuplicate']),
  lastNameAttempt: state.getIn(['ui', 'savedSearch', 'lastNameAttempt']),
  searchQuery: state.getIn(['search', 'catalogSearch', 'searchQuery', 'query']),
  fieldErrors: state.getIn(['ui', 'savedSearch', 'fieldErrors'])
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(SavedSearchActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SaveSearchContainer));



// WEBPACK FOOTER //
// ./app/containers/SaveSearchContainer.jsx